import React from "react";
import useDocumentTitle from "../../assets/utils/useDocumentTitle";
import { Breadcrumb, Footer, Header, Sidebar } from "../../components";
import "./style.scss";

function Pairtanah() {
  useDocumentTitle("Pajak air Tanah- BAPENDA BEKASI");
  return (
    <div className="page">
      <Header active="Pairtanah" />

      {/* main */}
      <main className="main-sb">
        <section className="content">
          <Breadcrumb path="Jenis Pelayanan / Pajak Air Tanah" />
          <div className="page-title-wrapper">
            <div className="page-title">Pajak Air Tanah</div>
          </div>

          {/* <p className="page-text">
            Dalam rangka pelaksanaan Peraturan Pemerintah Nomor 18 Tahun 2016 tentang Perangkat Daerah dan Peraturan Menteri Dalam Negeri Nomor 97 Tahun 2016 tentang Perangkat Daerah Provinsi DKI Jakarta, maka berdasarkan Peraturan Gubernur
            Nomor 154 Tahun 2020 tentang Organisasi dan Tata Kerja Perangkat Daerah dibentuklah Badan Pendapatan Daerah (Bapenda) Provinsi DKI Jakarta.
          </p> */}

          <p className="subpage-title"><strong>Pajak Air Tanah</strong></p>
          <p className="page-text">Pajak Air Tanah yang selanjutnya disingkat PAT adalah Pajak atas
pengambilan dan/atau pemanfaatan air tanah.
Air Tanah adalah air yang terdapat dalam lapisan tanah atau batuan di
bawah permukaan tanah. </p>
<p className="page-text"><strong>
Objek Pajak Air Tanah adalah pengambilan dan/atau pemanfaatan Air Tanah.</strong>

</p>
<p className="page-text"><strong>
Dasar pengenaan Pajak Air Tanah adalah pengambilan dan/atau pemanfaatan Air Tanah.</strong>
1. Dasar pengenaan PAT adalah nilai perolehan Air Tanah.<br></br>
2. Nilai perolehan Air Tanah sebagaimana dimaksud point 1 adalah
hasil perkalian antara harga air baku dengan bobot Air Tanah.<br></br>
3. Harga Air Baku sebagaimana dimaksud pada point 2 ditetapkan
berdasarkan biaya pemeliharaan dan pengendalian sumber daya Air Tanah.<br></br>
4. Bobot Air Tanah sebagaimana dimaksud pada point 2 dinyatakan dalam
koefisien yang didasarkan atas faktor-faktor berikut:<br></br>
a. jenis sumber air;<br></br>
b. lokasi sumber air;<br></br>
c. tujuan pengambilan dan/atau pemanfaatan air;<br></br>
d. volume air yang diambil dan/atau dimanfaatkan;<br></br>
e. kualitas air; dan<br></br>
f. tingkat kerusakan lingkungan yang diakibatkan oleh pengambilan
dan/atau pemanfaatan air.<br></br>
5. Besarnya nilai perolehan Air Tanah sebagaimana dimaksud pada point 2
dalam Daerah ditetapkan dengan Peraturan Wali Kota yang berpedoman
pada nilai perolehan Air Tanah yang ditetapkan oleh Gubernur.
</p>
<br></br>

<p className="page-text"><strong>Tarif Pajak Air Tanah ditetapkan sebesar 20% (dua puluh persen).</strong></p>

<br></br>
<p className="page-text"><strong>
DASAR HUKUM : </strong><br></br>
<a href="https://jdih.bekasikota.go.id/peraturan-daerah/view?id=525" target="_blank" rel="noreferrer"><font color="blue">Peraturan Daerah Kota Bekasi Nomor 1 Tahun 2024 Tentang Pajak Daerah Dan Retribusi Daerah</font></a>
</p>
         
        
         
         
          
        </section>
        <Sidebar />
      </main>

      <Footer />
    </div>
  );
}

export default Pairtanah;
